import React, { useEffect, useState } from "react";
import Button from "../modules/Button";
import MultiSelect from "../modules/MultiSelect";
import DropBtn from "../modules/DropBtn";
import avatar from "../../Assets/svg/avatar-img.svg";
import down from "../../Assets/svg/down arrow new.svg";
import RequestListView from "./RequestListView";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../Services";
import { addMentorInfo } from "../Connect/redux/actions";

function Requests() {
  const dispatch = useDispatch();
  const tokenData = useSelector((state) => state.tokens.tokens);
  const scholars = useSelector((state) => state.connect.scholarRequests);

  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "",
    countDown: " ",
    desc: "",
  });
  const getAlumni = async () => {
    try {
      const alumniData = await api.getRequests(
        tokenData.token,
        false,
        tokenData.applicationData.id
      );
      if (alumniData.statusCode == 200) {
        dispatch(
          addMentorInfo({
            type: "scholarRequests",
            value: alumniData.data ?[...alumniData.data]:[],
          })
        );
      // } else {
      //   dispatch(addMentorInfo({ type: "scholarRequests", value: [] }));
      }
      // if (mentorData.data) {
      //   dispatch(addMentorInfo([...mentorData.data]));
      // }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    getAlumni();
  }, []);
  useEffect(() => {
    console.log("scholars modified", scholars);
  }, [scholars]);
  console.log("scholars requests", scholars);

  return (
    <div className="request-page">
      {scholars?.map((item, index) => {
        return (
          <RequestListView
            getAlumni={() => getAlumni()}
            item={item}
            key={index}
          />
        );
      })}
    </div>
  );
}

export default Requests;
